<template>
  <div class="search">
    <div
      v-if="searchData && !searchData.data.length && !otherStyle.data.length"
      style="width: 100%"
    >
      <div
        v-if="!loading && !S_SearchData.noSearchData"
        class="searchNoData"
      >
        {{ S_SearchData[boxName] ? S_SearchData[boxName].name : "" }}
        资源库没有找到你搜索内容哦～
      </div>
      <div
        v-if="!loading && S_SearchData.noSearchData"
        class="searchNoData"
      >
        没有找到你搜索内容哦～
        <div
          class="btn"
          @click="showCustomWorksPopup"
        >我要定制</div>
      </div>
    </div>

    <div
      class="item"
      v-for="(item, index) in S_SearchData"
      :key="index"
      v-if="index !== 'isGlobalSearch' && index !== 'noSearchData' && item.num"
    >
      <div
        class="title"
        @click="
          toggleBox(item.type);
          itemDataSwitch = !itemDataSwitch;
        "
      >
        <span>{{ item.name }}</span>
        <i :class="{ airNum: !item.num }">{{ item.num }}</i>
      </div>
      <div
        class="itemData"
        v-if="index === boxName && itemDataSwitch"
      >
        <div class="searchData">
          <div
            class="data-list"
            v-if="searchData"
            :style="{
              height: searchData.data.length
                ? searchData.WFSheight + 30 + 'px'
                : 'auto',
            }"
          >
            <div
              class="itemSecens"
              v-if="boxName === 'template'"
              v-for="(itemL, index) in searchData.data"
              :key="index"
              @click="serchAddSprite(itemL)"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
                height: itemL.direction
                  ? itemL.direction == 2
                    ? '227px'
                    : '75px'
                  : '75px',
              }"
            >
              <img
                @mouseover="getCharacters($event, itemL)"
                @mouseout="closeCharacters()"
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="100%"
                :style="{
                  width: itemL.direction
                    ? itemL.direction == 2
                      ? '100%'
                      : 'auto'
                    : 'auto',
                  height: '100%',
                }"
              />
              <span
                class="label"
                v-if="itemL.payType && !UserEquity.exclusive"
                style="width: auto; padding: 0 3px"
              >¥ {{ itemL.price }}</span>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.f },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>

            <div
              class="itemSecens"
              v-if="boxName === 'scenes' || boxName === 'bg'"
              v-for="(itemL, index) in searchData.data"
              :key="index"
              @click="serchAddSprite(itemL)"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
                height: itemL.direction
                  ? itemL.direction == 2
                    ? '227px'
                    : '75px'
                  : '75px',
              }"
            >
              <img
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="100%"
                :style="{
                  width: itemL.direction
                    ? itemL.direction == 2
                      ? '100%'
                      : 'auto'
                    : 'auto',
                  height: '100%',
                }"
              />

              <material-payType-subscript
                :item="itemL"
                style="right: 4px; bottom: 4px"
              ></material-payType-subscript>
              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.favorites },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>

            <div
              class="itemCharacters thisCharacters"
              v-if="boxName === 'characters'"
              v-for="(itemL, indexL) in searchData.data"
              @mouseout="
                closeCharacters();
                loadLottie(
                  itemL.action[0],
                  { index: indexL, id: 'Csearch_' + indexL },
                  false
                );
              "
              @mouseover="
                getCharacters($event, itemL, true);
                loadLottie(
                  itemL.action[0],
                  { index: indexL, id: 'Csearch_' + indexL },
                  true
                );
              "
              :key="itemL.id"
              @click="serchAddSprite(itemL)"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
              }"
            >
              <img
                :src="$handleAssetsUrl(itemL.action[0].thumbnailUrl)"
                width="auto"
                height="100%"
              />
              <div
                class="Clottie"
                :lottiedom="'Csearch_' + indexL"
              ></div>

              <material-payType-subscript
                :item="itemL"
                style="right: 4px; bottom: 4px"
              ></material-payType-subscript>

              <span class="mask"></span>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.favorites },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>

            <div
              class="itemCharacters"
              v-if="boxName === 'props'"
              v-for="(itemL, indexL) in searchData.data"
              :key="itemL.id"
              @click="serchAddSprite(itemL)"
              @mouseenter="watchItem(itemL, true)"
              @mouseleave="watchItem(itemL, false)"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
              }"
            >
              <img
                v-if="itemL.fileType != 42"
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="auto"
                height="100%"
              />
              <video
                v-if="itemL.fileType == 42"
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="auto"
                height="100%"
                loop="loop"
                :ref="'searchPropsVideo_' + itemL.id"
              ></video>

              <material-payType-subscript
                :item="itemL"
                style="right: 4px; bottom: 4px"
              ></material-payType-subscript>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.favorites },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>

            <div
              class="itemCharacters"
              v-if="boxName === 'gif'"
              v-for="(itemL, indexL) in searchData.data"
              :key="itemL.id"
              @click="serchAddSprite(itemL)"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
              }"
            >
              <img
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="auto"
                height="100%"
              />
              <div class="maskGif">
                <img
                  :src="$handleAssetsUrl(itemL.url)"
                  width="auto"
                  height="100%"
                />
              </div>

              <material-payType-subscript
                :item="itemL"
                style="right: 4px; bottom: 4px"
              ></material-payType-subscript>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.favorites },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>

            <div
              class="itemCharacters"
              v-if="boxName === 'shapes'"
              v-for="(itemL, indexL) in searchData.data"
              :key="itemL.id"
              @click="serchAddSprite(itemL)"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
              }"
            >
              <img
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="auto"
                height="100%"
              />

              <material-payType-subscript
                :item="itemL"
                style="right: 4px; bottom: 4px"
              ></material-payType-subscript>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.favorites },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>

            <div
              class="itemCharacters"
              v-if="boxName === 'text'"
              v-for="(itemL, indexL) in searchData.data"
              :key="itemL.id"
              @click="serchAddSprite(itemL)"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
              }"
            >
              <img
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="auto"
                height="100%"
              />

              <material-payType-subscript
                :item="itemL"
                style="right: 4px; bottom: 4px"
              ></material-payType-subscript>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.favorites },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>

            <div
              class="itemSound"
              v-if="boxName === 'sound'"
              v-for="(itemL, indexL) in searchData.data"
              :key="itemL.id"
              :style="{
                top: itemL.topWFC + 'px',
                left: itemL.leftWFC + 'px',
              }"
            >
              <!-- 播放 -->
              <div class="playGrid">
                <el-tooltip
                  effect="dark"
                  content="试听"
                  placement="bottom"
                  :open-delay="1000"
                >
                  <span
                    :class="{
                      play: listenSound != itemL.id,
                      stop: listenSound == itemL.id,
                    }"
                    style="margin: 0"
                    @click="play(itemL)"
                  ></span>
                </el-tooltip>
              </div>
              <!--  -->
              <div class="detailGrid">
                <el-tooltip
                  effect="dark"
                  :content="itemL.title"
                  placement="left"
                  :open-delay="1000"
                >
                  <p class="name">{{ itemL.title }}</p>
                </el-tooltip>
                <p class="duration">{{ itemL.duration | formatTime }}</p>
              </div>
              <div class="infoGrid">
                <div class="staticGrid">
                  <div class="logoGrid">
                    <company
                      :itemData="itemL"
                      :boxName="boxName"
                    />
                  </div>
                  <div class="payGrid">
                    <payType-subscript-small
                      :item="itemL"
                      style="right: 4px; bottom: 4px"
                    ></payType-subscript-small>
                  </div>
                </div>

                <div class="selectedGrid">
                  <el-tooltip
                    effect="dark"
                    content="收藏"
                    placement="top"
                    :open-delay="1000"
                  >
                    <i
                      class="collection_sprite_icon"
                      :class="[
                        { collection_sprite_icon_active: itemL.favorites },
                        'vipResource_' + itemL.id,
                      ]"
                      style="
                        display: inline-block;
                        position: relative;
                        right: 0;
                        top: 0;
                      "
                      @mouseover="
                        collectionSpriteIconTit($event);
                        stopDocument($event);
                      "
                      @click="
                        stopDocument($event);
                        collectionSpriteIconFS(itemL, $event);
                      "
                    ></i>
                  </el-tooltip>

                  <el-tooltip
                    effect="dark"
                    content="使用"
                    placement="bottom"
                    :open-delay="1000"
                  >
                    <span
                      :class="BGM.id === itemL.id ? 'select-active' : 'select'"
                      @click="
                        setMusic(itemL);
                        materialPushAnalysis({
                          type: 'music',
                          id: itemL.id,
                          name: itemL.name,
                        });
                      "
                      style="margin: 0 10px"
                    ></span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              !loading &&
              searchData &&
              !searchData.data.length &&
              otherStyle.data.length
            "
            style="width: 100%"
          >当前风格内没有搜索的素材哦～</div>

          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 60px"
          ></div>
        </div>

        <div
          class="otherStyle"
          v-if="otherStyle.data.length"
          :style="{
            height: otherStyle.data.length
              ? otherDataWaterfall.WFSheight + 30 + 'px'
              : 'auto',
            'padding-top': otherStyle.data.length
              ? otherDataWaterfall.WFSheight - 10 + 'px'
              : '0px',
          }"
        >
          <div
            class="itemSecens"
            v-if="boxName === 'scenes' || boxName === 'bg'"
            v-for="(itemL, index) in otherStyle.data"
            :key="index"
            @click="serchAddSprite(itemL)"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
              height: itemL.direction
                ? itemL.direction == 2
                  ? '227px'
                  : '75px'
                : '75px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="100%"
              :style="{
                width: itemL.direction
                  ? itemL.direction == 2
                    ? '100%'
                    : 'auto'
                  : 'auto',
                height: '100%',
              }"
            />

            <material-payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></material-payType-subscript>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            class="itemCharacters thisCharacters"
            v-if="boxName === 'characters'"
            v-for="(itemL, indexL) in otherStyle.data"
            @mouseout="
              closeCharacters();
              loadLottie(
                itemL.action[0],
                { index: indexL, id: 'COsearch_' + indexL },
                false
              );
            "
            @mouseover="
              getCharacters($event, itemL, true);
              loadLottie(
                itemL.action[0],
                { index: indexL, id: 'COsearch_' + indexL },
                true
              );
            "
            :key="itemL.id"
            @click="serchAddSprite(itemL)"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.action[0].thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <div
              class="Clottie"
              :lottiedom="'COsearch_' + indexL"
            ></div>

            <material-payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></material-payType-subscript>

            <span class="mask"></span>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            class="itemCharacters"
            v-if="boxName === 'props'"
            v-for="(itemL, indexL) in otherStyle.data"
            :key="itemL.id"
            @click="serchAddSprite(itemL)"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />

            <material-payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></material-payType-subscript>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            class="itemCharacters"
            v-if="boxName === 'gif'"
            v-for="(itemL, indexL) in otherStyle.data"
            :key="itemL.id"
            @click="serchAddSprite(itemL)"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <div class="maskGif">
              <img
                :src="$handleAssetsUrl(itemL.url)"
                width="auto"
                height="100%"
              />
            </div>

            <material-payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></material-payType-subscript>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            class="itemCharacters"
            v-if="boxName === 'shapes'"
            v-for="(itemL, indexL) in otherStyle.data"
            :key="itemL.id"
            @click="serchAddSprite(itemL)"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />

            <material-payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></material-payType-subscript>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            class="itemCharacters"
            v-if="boxName === 'text'"
            v-for="(itemL, indexL) in otherStyle.data"
            :key="itemL.id"
            @click="serchAddSprite(itemL)"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />

            <material-payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></material-payType-subscript>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            class="itemSound"
            v-if="boxName === 'sound'"
            v-for="(itemL, indexL) in otherStyle.data"
            :key="itemL.id"
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <div
              class="detail"
              style="justify-content: end"
            >
              <el-tooltip
                effect="dark"
                :content="itemL.title"
                placement="left"
                :open-delay="1000"
              >
                <p
                  class="name"
                  style="maxwidth: 130px"
                >{{ itemL.title }}</p>
              </el-tooltip>
              <company
                :itemData="itemL"
                :boxName="boxName"
              />
              <p class="duration">{{ itemL.duration | formatTime }}</p>
            </div>

            <div
              class="detail"
              style="justify-content: end; align-items: center"
            >
              <payType-subscript-small
                :item="itemL"
                style="right: 4px; bottom: 4px"
              ></payType-subscript-small>

              <el-tooltip
                effect="dark"
                content="试听"
                placement="bottom"
                :open-delay="1000"
              >
                <span
                  :class="{
                    play: listenSound != itemL.id,
                    stop: listenSound == itemL.id,
                  }"
                  @click="play(itemL)"
                >
                  <i></i>
                </span>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                content="使用"
                placement="bottom"
                :open-delay="1000"
              >
                <span
                  :class="BGM.id === itemL.id ? 'select-active' : 'select'"
                  @click="
                    setMusic(itemL);
                  "
                ></span>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    { collection_sprite_icon_active: itemL.favorites },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                  style="position: relative; top: -2px; right: 0"
                ></i>
              </el-tooltip>
            </div>
          </div>

          <div
            v-loading="otherLoding"
            v-if="otherLoding"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 60px"
          ></div>
        </div>
      </div>
    </div>

    <SwitchStyle :styles="{ paddingTop: 0, marginTop: '-12px' }" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SwitchStyle from "./switchStyle";
import Analysis from "../../../mixins/analysis/materialBu";
import vipLabel from "./vipLabel";
import MaterialPayTypeSubscript from "@/components/common/materialPayTypeSubscript";
import PayTypeSubscriptSmall from "@/components/common/payTypeSubscriptSmall";
import company from "./company";
import addSound from '../addSound.js';

export default {
  mixins: [Analysis, addSound],
  data () {
    return {
      otherStyle: {
        data: [], // 数据数组
        scollTop: 0, // 滚动刷新的高度
        search: {
          // 搜索请求数据
          pIndex: 1,
          type: 0,
          sOfPage: 24,
          fPage: 24,
          style: 0,
          keyword: "",
          findAll: 1,
        },
      },
      otherDataNext: [],
      otherDataWaterfall: {
        rowNum: {
          // 存在几行
          sound: 1,
          scenes: 2,
          template: 2,
          bg: 2,
          shapes: 3,
          props: 3,
          gif: 3,
          text: 3,
          characters: 3,
        },
        itemHeight: {
          // 每个元素的高度
          sound: 1,
          shapes: 90,
          scenes: 90,
          template: 90,
          bg: 90,
          props: 110,
          gif: 110,
          text: 95,
          characters: 110,
          scenesH: 242,
          bgH: 242,
        },
        itemWeight: {
          // 每个元素的宽度
          sound: 58,
          shapes: 94,
          scenes: 140,
          template: 140,
          bg: 140,
          props: 94,
          gif: 94,
          text: 94,
          characters: 94,
        },
        listHeight: {},
        listWidth: 140,
        WFSheight: 0,
      },
      scollTop: {
        // 控制滚动条的数据
        default: 0, // 默认添加的高度
        material: 88, // 单个元素的高度
        rowNum: 2, // 每行个数
        scollTop: 0, // 判断是否定位的最初位置
        add: true, // 判断添加
      },
      otherLoding: false,
      BGM: {
        // 背景音乐数据
        id: null,
      },
      itemDataSwitch: true,
      searchData: {
        data: [],
      },
      listenSound: "",
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "StyleArrayMsg",
      "S_GlobalSearch",
      "S_SearchData",
      "S_Scenes",
      "StyleMsg",
      "TOOL",
      "UserEquity",
      "S_SearchName",
      "WorksId",
      "WorksName",
    ]),
    ...mapGetters({
      trackingData: "tracking/trackingData",
      musicArr: 'addSoundtrack/getMusicArr',
      dubbingArr: 'addSoundtrack/getDubbingArr'
    }),
  },
  props: ["boxName", "searchDataArray", "loading", "dataMsg"],
  watch: {
    dataMsg: function (val, oldval) {
      // 关键词搜索事件
      if (this.dataMsg === this.boxName) {
        if (this.S_GlobalSearch) {
          this.BGM.id = this.TOOL.sound ? this.TOOL.sound.resourceId : null;
          this.getStyleBrink();
        }
      }
    },
    S_GlobalSearch: function (val, oldval) {
      // 关键词搜索事件
      this.otherStyle.search.pIndex = 1;
    },
    searchDataArray: function (val, oldval) {
      // 关键词搜索事件
      if (this.S_GlobalSearch) {
        this.itemDataSwitch = true;
        this.searchData = this.searchDataArray.search;
      }
    },
    "S_Scenes.data": function (val, oldval) {
      // 关键词搜索事件
      this.otherStyle.search.pIndex = 1;
      if (this.dataMsg === this.boxName) {
        if (this.S_GlobalSearch) {
          this.getStyleBrink();
        }
      }
    },
    StyleMsg: function (val, oldval) {
      // 关键词搜索事件
      this.otherStyle.search.pIndex = 1;
    },
    searchData: function (val, oldval) {
      this.clearData();
    },
    otherDataNext: function (val, oldval) {
      this.clearData();
    },
    "TOOL.sound": function () {
      // 监控bgm改变
      if (this.TOOL.sound) {
        this.BGM.id = this.TOOL.sound.resourceId;
      }
    },
    S_SearchName: function (val, oldval) {
      // 关键词搜索事件
      this.listenSound = "";
    },
  },
  filters: {
    // ----音乐
    formatTime (duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
    // ----音乐
  },
  mounted () {
    this.$bus.on("addSearchData_vue", (data) => {
      this.clearData();
    });
    this.$bus.on("search_listen_BGM", (data) => {
      if (data) {
        this.listenSound = "";
      }
    });
    this.$bus.on("rightSlideBoxBroadcast_vue", (data) => {
      this.computeScrollTop(data.scrollTop); // 计算当前高度判断刷新等功能
    });

    let otherData = this.otherDataWaterfall.rowNum[this.boxName];
    for (let o = 0; o < otherData; o++) {
      this.otherDataWaterfall.listHeight["WFSS" + o] = {
        index: o,
        height: 15,
      };
    }
  },
  methods: {
    showCustomWorksPopup () {
      this.$bus.emit("createCustomWorks");
      this.$modal.show("customWorks");
    },
    play (music) {
      if (music.id == this.listenSound) {
        this.listenSound = "";
      } else {
        this.listenSound = music.id;
      }
      this.$bus.emit("start_listen_BGM", music);
    },
    toggleBox (data) {
      // 切换风格
      if (this.boxName !== data) {
        this.$bus.emit("materialPane_vue", { type: data });
        if (data == "scenes") {
          this.$bus.emit("OpenScenesLib", {});
        }
      }
    },
    serchAddSprite (data) {
      let item = data;
      sensors.track("searchResultClick", {
        choose_price: this.trackingData.choose_price,
        click_type: "添加到画布",
        keyword_type: this.trackingData.keyword_type,
        keyword: this.trackingData.keyword,
        order_method: this.trackingData.order_method,
        position_number: "",
        search_source: "编辑器素材栏",
        template_id: this.$route.template || "",
        template_name: "",
        template_style: "",
        template_type: "",
        material_id: item.id,
        // material_name: item.title,
      });
      // 添加使用穿进来的参数
      switch (this.boxName) {
        case "scenes":
          data = data.id;
          this.$emit("addsprite", data, "scenes", { favorites: true });
          return;
          break;
        case "bg":
          data = data;
          break;
        case "characters":
          data = {
            url: data.action[0].url,
            id: data.action[0].id,
            actionId: data.action[0].id,
            fileType: 10
          };
          break;
      }
      this.$emit("addsprite", data);
    },
    getStyleBrink () {
      // 此风格之外的素材
      this.otherStyle.search.type = this.S_SearchData[
        this.boxName
      ].resourceType;
      this.otherStyle.search.style = this.StyleMsg;
      this.otherStyle.search.keyword = this.S_SearchData[this.boxName].data;
      let dataURL = "common/material";
      switch (
      this.boxName // 不同盒子的数据改变
      ) {
        case "text":
        case "characters":
        case "props":
          this.scollTop.rowNum = 3;
          break;
        case "sound":
          this.scollTop.rowNum = 1;
          this.scollTop.material = 60;
          break;
        case "template":
          dataURL = this.S_SearchData[this.boxName].resourceType;
          delete this.otherStyle.search.type;
          this.scollTop.rowNum = 2;
          break;
        default:
          this.scollTop.rowNum = 2;
      }

      if (this.otherStyle.search.pIndex === 1) {
        this.otherStyle.data = [];
        this.otherDataNext = [];
      }
      this.otherLoding = true;
      this.$http
        .get("/api/" + dataURL, {
          params: this.otherStyle.search,
        })
        .then((res) => {
          let resData = res.data.code;
          let dataArray = res.data.data;
          this.otherDataNext =
            resData == 200
              ? this.otherDataNext.concat(dataArray)
              : this.otherDataNext;

          if (resData == 200 && "data" in res.data && res.data.data.length) {
            this.otherStyle.search.pIndex++;
          }
          this.otherLoding = false;
          // console.log(this.otherStyle, '此风格之外的素材', this.searchData)
          if (resData == 200 && res.data.data && res.data.data.length) {
            // 判断下拉刷新
            this.scollTop.add = true;
          }
        });
    },
    clearData () {
      if (this.boxName == "personal") return;
      let dataArray = this.otherDataNext;

      let dataLength = 0; // 计算高度判断下拉刷新
      if (this.searchData && this.searchData.data.length) {
        for (let i = 0; i < dataArray.length; i++) {
          if (dataArray[i]) {
            let dataId = dataArray[i].id;
            for (let t = 0; t < this.searchData.data.length; t++) {
              if (dataId === this.searchData.data[t].id) {
                dataArray.splice(i, 1);
              }
            }
          }
        }
      }
      this.otherStyle.data = this.waterfallCompute(this.otherDataNext);
      dataLength = this.otherStyle.data.length;
      // console.log(dataArray);

      if (dataLength) {
        this.otherStyle.scollTop =
          Math.ceil(dataLength / this.scollTop.rowNum) *
          this.scollTop.material +
          40; // 根据高度判断下拉刷新
        if (this.searchData.data.length) {
          this.scollTop.scollTop =
            Math.ceil(this.searchData.data.length / this.scollTop.rowNum) *
            this.scollTop.material;
          this.otherStyle.scollTop =
            this.otherStyle.scollTop +
            Math.ceil(this.searchData.data.length / this.scollTop.rowNum) *
            this.scollTop.material;
        } else {
          this.scollTop.scollTop = 140;
          this.otherStyle.scollTop = this.otherStyle.scollTop + 100;
        }
      } else {
        this.otherStyle.scollTop = 0; // 根据高度判断下拉刷新
      }
    },
    computeScrollTop (data) {
      // 计算当前高度判断刷新等功能
      if (this.scollTop.scollTop) {
        if (this.searchData.judge) {
          this.$bus.emit("searchDataUpdata_vue", { type: true });
        }
        if (data > this.scollTop.scollTop) {
          let isadd = data - this.scollTop.scollTop, // 达到加载位置加载
            judgeAdd = this.otherStyle.scollTop + this.scollTop.scollTop; // judgeAdd加载位置
          if (isadd > 0 && this.scollTop.add) {
            // 根据高度判断下拉刷新
            this.getStyleBrink();
            this.scollTop.add = false;
          }
        }
      }
    },
    //--角色hover函数--
    getCharacters (el, data, type) {
      // 唤出弹出框
      if (type) {
        data.fileType = data.action[0].fileType;
      }
      this.$bus.emit("itemPreview_vue", {
        data: data,
      });
      this.addtime = setTimeout(() => {
        this.$bus.emit("FeaturesPop_vue", {
          name: "charactersSprite",
          posx: el.pageX - el.offsetX,
          posy: el.pageY - el.offsetY,
          data: data,
          type: 2,
          boxName: this.boxName,
        });
        if (this.addtime) {
          clearTimeout(this.addtime);
        }
      }, 1000);
    },
    closeCharacters () {
      if (this.addtime) {
        clearTimeout(this.addtime);
      }
      this.$bus.emit("setTimeOut_vue", {
        name: this.boxName,
      });
    },
    loadLottie (data, dom, judge) {
      // 加载lottie
      if (judge) {
        let domtit = "div[lottiedom='" + dom.id + "']";
        let lottiedom = $(domtit);
        let option = {
          container: lottiedom[0],
          renderer: "svg",
          loop: true,
          autoplay: false,
          path: "https://resources.laihua.com/" + data.url,
        };
        this.lottiedata = lottie.loadAnimation(option);
        this.lottiedata.play();
      } else {
        if (this.lottiedata) {
          this.lottiedata.stop();
          this.lottiedata.destroy();
          this.lottiedata = null;
        }
        // console.log(this.lottiedata, '-----------------------|||', $(this.$refs[dom.id][dom.index]))
      }
    },
    setSound (data) {
      // 防止重复设置
      if (this.TOOL.sound && this.TOOL.sound.resourceId === data.id) return;
      // 添加背景音乐
      this.TOOL.setSound(
        {
          // 添加全局bgm
          resourceId: data.id, // 资源id 用于查询资源的信息，下同
          title: data.title,
          fileType: data.fileType,
          url: this.$handleAssetsUrl(data.url), // 资源路径
          isLoop: true, // 是否循环
          volume: 50, // 音量0-100
          subtitle: null, // 字幕（预留字段）
          endTime: 0,
          startTime: 0,
        },
        true
      );
      // this.$store.commit('save_bgm', data);
    },
    showVolume () {
      // 打开音乐设置面板
      this.$bus.emit("FeaturesPop_vue", {
        name: "volume_adjust",
        posx: 0,
        posy: 0,
        type: 1,
      });
    },
    waterfallCompute (data) {
      // 瀑布流计算
      if (!data) return [];
      let listKey = {},
        item = "";
      for (item in this.otherDataWaterfall.listHeight) {
        if (item.indexOf("WFSS") >= 0) {
          this.otherDataWaterfall.listHeight[item].height = 15;
        }
      }
      if (!data.length) return [];
      for (let i = 0; i < data.length; i++) {
        let itemList = [];
        for (item in this.otherDataWaterfall.listHeight) {
          if (item.indexOf("WFSS") >= 0) {
            itemList.push({
              key: item,
              data: this.otherDataWaterfall.listHeight[item],
            });
          }
        }
        listKey = false;
        if (itemList.length == 1) {
          listKey = itemList[0].key;
        } else {
          for (let v = 0; v < itemList.length; v++) {
            if (itemList[v + 1]) {
              let numdata =
                itemList[v].data.height - itemList[v + 1].data.height;

              if (numdata == 0 && !listKey) {
                listKey = itemList[v].key;
              } else if (numdata > 0) {
                listKey = itemList[v + 1].key;
              } else if (numdata < 0) {
                listKey = itemList[v].key;
              }
            }
          }
        }
        let iwidth = this.otherDataWaterfall.itemWeight[this.boxName],
          iheight = this.otherDataWaterfall.itemHeight[this.boxName],
          Aheight = this.otherDataWaterfall.listHeight[listKey];

        if (!Aheight) return [];
        data[i].leftWFC = iwidth * Aheight.index;
        data[i].topWFC = Aheight.height > 15 ? Aheight.height : 15;

        switch (this.boxName) {
          case "bg":
          case "scenes":
          case "template":
            switch (data[i].direction) {
              case 2:
                Aheight.height += this.otherDataWaterfall.itemHeight[
                  this.boxName + "H"
                ];
                break;
              default:
                Aheight.height += iheight;
                break;
            }
            break;
          default:
            Aheight.height += iheight;
            break;
        }

        this.otherDataWaterfall.WFSheight = Aheight.height;
      }
      return data;
    },
    watchItem (data, type) {
      switch (data.fileType) {
        case 42:
          let videoDom = this.$refs["searchPropsVideo_" + data.id][0];
          if (type) {
            videoDom.currentTime = 0;
            videoDom.play();
            this.materialPushAnalysis({ type: "propsSoundSprite" });
          } else {
            videoDom.pause();
          }
          break;
      }
    },
    stopDocument (e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    collectionSpriteIconFS (data, e) {
      // 收藏/取消收藏
      let fileTypes = {
        shapes: [6, 7, 8, 9, 28, 29, 33],
        gif: [32],
      };
      let isCollection = e.target.className,
        msgData = {
          id: data.id,
          type: 3,
        };
      let dataURL = "user/favorites";
      switch (this.boxName) {
        case "bg":
          msgData.type = 3;
          break;
        case "characters":
          msgData.type = 14;
          break;
        case "gif":
          msgData.type = 37;
          break;
        case "props":
          msgData.type = 17;
          if (fileTypes.shapes.indexOf(data.fileType) > -1) {
            msgData.type = 15;
          } else if (fileTypes.gif.indexOf(data.fileType) > -1) {
            msgData.type = 37;
          }
          break;
        case "shapes":
          msgData.type = 15;
          break;
        case "scenes":
          msgData.type = 12;
          break;
        case "sound":
          msgData.type = 5;
          break;
        case "text":
          msgData.type = 16;
          break;
        case "template":
          dataURL = "user/template/favorites";
          delete msgData.type;
          break;
      }
      isCollection =
        isCollection.indexOf("collection_sprite_icon_active") >= 0
          ? true
          : false;

      if (isCollection) {
        // 已收藏
        if (this.boxName == "template") {
          dataURL = "user/template/cancelFavorites";
          delete msgData.type;
        } else {
          msgData.isCancel = 1;
        }
      }
      let item = data;
      let collect_contents = {
        template: "模板",
        scenes: "场景",
        bg: "背景",
        text: "文字",
        characters: "人物",
        props: "道具",
        sound: "声音",
      };
      sensors.track("collectContent", {
        author_id: this.UserMsg.id,
        author_name: this.UserMsg.nickname,
        business: "",
        collect_content: collect_contents[this.boxName] || "",
        content_duration: this.TOOL.getDuration() / 1000,
        content_id: this.WorksId,
        content_name: this.WorksName,
        material_id: item.id,
        // material_name: item.title,
        module: "编辑器素材栏",
        operation_type: msgData.isCancel == 1 ? "取消收藏" : "收藏",
        price_type: ((payType) => {
          if (payType == 0) {
            return "免费";
          }
          if (payType == 1) {
            return "付费";
          }
          if (payType == 4) {
            return "会员免费";
          }
          return "全部价格";
        })(item.payType),
        price: item.price - 0,
        purpose: "",
        template_id: this.$route.template || "",
        template_name: "",
        template_style: "",
        template_type: "",
      });
      this.$http({
        url: "/api/" + dataURL,
        method: "post",
        data: msgData,
      }).then((res) => {
        let resData = res.data;

        if (resData.code == 200) {
          this.collectionSpriteIconTit(e, "vipResource_" + data.id);
        }
      });
    },
    collectionSpriteIconTit (e, className) {
      let titDom = e.target.attributes["aria-describedby"].value,
        num = 0,
        titDomTXT;
      let isCollection = e.target.className;
      isCollection =
        isCollection.indexOf("collection_sprite_icon_active") >= 0
          ? true
          : false;

      let timeoutid = setInterval(() => {
        num++;
        titDomTXT = document.getElementById(titDom);
        if (titDomTXT) {
          titDomTXT.style.opacity = "0";
          let name = titDomTXT.innerHTML.indexOf("<");
          name = titDomTXT.innerHTML.substring(name);

          if (isCollection) {
            // 已收藏
            name = "取消收藏" + name;
          } else {
            // 未收藏
            name = "收藏" + name;
          }
          titDomTXT.innerHTML = name;
          titDomTXT.style.opacity = "1";
        }
        let delDom = document.getElementsByClassName(className);
        if (delDom.length) {
          for (let i = 0; i < delDom.length; i++) {
            // 循环添加删除显示收藏的元素的class
            if (isCollection) {
              // 已收藏

              delDom[i].classList.remove("collection_sprite_icon_active");
            } else {
              // 未收藏

              delDom[i].classList.add("collection_sprite_icon_active");
            }
          }
        }
        if (num > 30 || titDomTXT) {
          clearInterval(timeoutid);
        }
      }, 50);
    },
  },
  components: {
    SwitchStyle,
    vipLabel,
    company,
    MaterialPayTypeSubscript,
    PayTypeSubscriptSmall,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search {
  padding-top: 10px;

  .itemData {
    .searchData {
      min-height: 45px;
    }

    .otherStyle {
      position: relative;
      min-height: 100px;
      padding-top: 8px;
      margin-bottom: 15px;
      border-top: 2px solid #ddddec;

      &:before {
        content: "其他风格";
        position: absolute;
        top: -10px;
        right: 0;
        left: 0;
        width: 90px;
        margin: 0 auto;
        background: #fff;
      }
    }

    .otherStyle,
    .data-list {
      position: relative;

       > div {
        position: absolute;

         > img {
          // position: absolute;
          // top: 0;
          // right: 0;
          // left: 0;
          // bottom: 0;
          // z-index: 0;
          // margin: auto;
          // max-width: 100%;
          // max-height: 100%;
          // width: auto;
          // height: auto;
          width: 100%;
          height: 100%;

          object-fit: cover;
        }
      }
      .itemSound,
      .itemCharacters,
      .thisCharacters {
        .collection_sprite_icon {
          position: absolute;
          top: 5px;
          right: 5px;
          z-index: 100;
          width: 22px;
          height: 22px;
          background: url("../../../../../static/svg/collection-icon.svg")
          no-repeat center;
          cursor: pointer;
          opacity: 0;
        }
        .collection_sprite_icon_active {
          background: url("../../../../../static/svg/collection-icon-active.svg")
          no-repeat center;
        }
        &:hover {
          .collection_sprite_icon {
            opacity: 1;
          }
        }
      }
      .itemSecens {
        overflow: hidden;
        width: 130px;
        height: 75px;
        border: 2px solid #fff;
        border-radius: 3px;
        & > .collection_sprite_icon {
          opacity: 0;
        }

        & > img {
          width: 100% !important;
          height: 100% !important;
        }

        &:hover {
          border-color: #5778fb;
          & > .collection_sprite_icon {
            opacity: 1;
          }
        }
      }

      .thisCharacters {
        &:hover {
          .Clottie {
            background: #fff;
          }
        }
      }

      .itemCharacters {
        overflow: hidden;
        width: 80px;
        height: 85px;
        border: 2px solid #fff;
        border-radius: 3px;
        cursor: pointer;

        &:hover {
          border-color: #5778fb;
        }

        video,
        img {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 0;
          width: auto;
          max-width: 100%;
          height: auto;
          max-height: 100%;
          margin: auto;
        }
        .maskGif,
        .Clottie,
        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .Clottie {
          z-index: 5;
        }
        .mask {
          z-index: 15;
        }
        .maskGif {
          z-index: 5;
          height: 100%;
          background: #fff;
          transition: all .3s;
          opacity: 0;
        }

        .modify {
          position: absolute;
          right: 5px;
          bottom: 5px;
          width: 40px;
          height: 18px;
          color: #fff;
          line-height: 18px;
          background: rgba(0, 0, 0, .5);
          border-radius: 5px;
        }

        .modify {
          width: 35px;
          height: 35px;
          transition: all .3s;
          cursor: pointer;
          opacity: 0;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
          .maskGif {
            opacity: 1;
          }
        }
      }

      .itemSound {
        display: flex;
        //flex-wrap: wrap;
        align-items: stretch;
        width: 270px;
        height: 60px;
        background-color: #fafafd;
        border: solid 1px #dbdff0;
        border-radius: 4px;
        //padding: 5px;

        &:hover {
          background-color: #dbdff0;
          .select,
          .edit,
          .select-active {
            display: inline-flex;
          }
          .selectedGrid {
            display: flex;
          }
          .staticGrid {
            display: none;
            opacity: 0;
          }
          // .play,
          // .stop,
          // .el-icon-loading {
          //   display: inline-flex;
          // }
        }
        .stop,
        .play,
        .el-icon-loading {
          display: block;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 22px;
          background-color: #737596;
          border-radius: 50%;
          cursor: pointer;
          i {
            display: inline-block;
            width: 0;
            height: 0;
            margin-left: 7px;
            border: 7px solid #fff;
            border-color: transparent transparent transparent #fff;
          }
        }
        .play {
          background: url("../../../../../static/svg/materialPane/music/play.svg")
          no-repeat center;
        }
        .stop {
          background: url("../../../../../static/svg/materialPane/music/pause.svg")
          no-repeat center;
          i {
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-left: 0;
            background: #fff;
            border: none;
          }
        }
        div.detail {
          display: flex;
          justify-content: flex-start;
          width: 100%;
          p.name {
            display: block;
            overflow: hidden;
            color: #474261;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p.duration {
            position: absolute;
            top: 5px;
            right: 5px;
            color: #a5a7c6;
            text-align: left;
          }
        }
        .select,
        .select-active {
          display: none;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 22px;
          margin: 0 10px;
          border-radius: 50%;
          cursor: pointer;
        }
        .select {
          background: url("../../../../../static/svg/select.svg") no-repeat
          center;
          &:hover {
            background: url("../../../../../static/svg/select-active.svg")
            no-repeat center;
          }
        }
        .select-active {
          background: url("../../../../../static/svg/select-active.svg")
          no-repeat center;
        }

        .modify {
          position: absolute;
          right: 5px;
          bottom: 5px;
          width: 40px;
          height: 18px;
          color: #fff;
          line-height: 18px;
          background: rgba(0, 0, 0, .5);
          border-radius: 5px;
        }
        .modify {
          width: 35px;
          height: 35px;
          transition: all .3s;
          cursor: pointer;
          opacity: 0;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }

        .playGrid {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 52px;
          height: 100%;
        }
        .detailGrid {
          position: relative;
          flex-grow: 1;
          width: 137px;
          //background-color: red;
          height: 100%;
          .name {
            position: absolute;
            top: 13px;
            display: block;
            overflow: hidden;
            max-width: 130px;
            color: #474261;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .duration {
            position: absolute;
            top: 35px;
            left: 0;
            color: #a5a7c6;
            font-size: 12px;
            text-align: left;
          }
        }
        .infoGrid {
          position: relative;
          width: 81px;
          height: 100%;
          .staticGrid {
            position: absolute;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-end;
            width: 63px;
            height: 100%;
            padding-right: 10px;
            .logoGrid {
              margin-top: 10px;
              margin-bottom: 7px;
            }
            .payGrid {
              height: 16px;
            }
          }
          .selectedGrid {
            position: absolute;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .item {
    width: 270px;
    margin: 0 0;
    margin-bottom: 10px;

    .title {
      position: relative;
      height: 40px;
      background-color: #f0f0f8;
      cursor: pointer;

      span {
        position: absolute;
        top: 11px;
        left: 25px;
        height: 14px;
        color: #474261;
        font-size: 14px;
      }

      i {
        position: absolute;
        top: 11px;
        right: 10px;
        min-width: 28px;
        height: 20px;
        color: #fff;
        font-size: 14px;
        font-stretch: normal;
        font-style: normal;
        font-weight: normal;
        line-height: 20px;
        background-color: #e84848;
        border-radius: 10px;

        &.airNum {
          background: #948d8d;
        }
      }
    }
  }

  .searchNoData {
    position: relative;
    margin-top: 200px;
    margin-bottom: 30px;

    &:before {
      content: "";
      position: absolute;
      top: -95px;
      right: 0;
      left: 0;
      width: 83px;
      height: 91px;
      margin: 0 auto;
      background: url("/static/img/laihua-air.png");
    }
  }
  .label {
    position: absolute;
    right: 5px;
    bottom: 5px;
    z-index: 10;
    width: 30px;
    height: 18px;
    color: #fff;
    line-height: 18px;
    background: #d83d60;
    border-radius: 5px;
  }
}

.btn {
  width: 160px;
  height: 40px;
  margin: auto;
  margin-top: 77px;
  margin-bottom: 16px;
  color: #fff;
  line-height: 40px;
  background-color: #5778fb;
  border-radius: 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/search.vue